"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _underscore = _interopRequireDefault(require("underscore"));

var _backbone = _interopRequireDefault(require("backbone"));

var _backboneValidation = _interopRequireDefault(require("backbone-validation"));

var _backboneTrackit = _interopRequireDefault(require("backbone-trackit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modelsToTrack = [];
var modelForSave = null;
var handleSaveHandler = null;
var TrackingMixin = {
  _allModelsToTrack: modelsToTrack,
  resetAttributesForAllTrackedModels: function resetAttributesForAllTrackedModels() {
    _underscore.default.each(modelsToTrack, function (model) {
      model.resetAttributes && model.resetAttributes();
    }, this);
  },
  saveHandlerCompleted: function saveHandlerCompleted() {
    this._resetTrackingForAllModels();
  },
  saveMainModel: function saveMainModel(options) {
    if (handleSaveHandler) {
      handleSaveHandler(options);
    } else {
      this._saveModel(_underscore.default.extend({}, options, {
        model: modelForSave
      }));
    }
  },
  getSaveModelPromise: function getSaveModelPromise(options) {
    var thisView = this;
    return function () {
      var deferred = _jquery.default.Deferred();

      thisView._saveModel(_underscore.default.extend({}, options, {
        success: deferred.resolve,
        error: deferred.reject
      }));

      return deferred.promise();
    };
  },
  getFetchModelPromise: function getFetchModelPromise(options) {
    return function () {
      var deferred = _jquery.default.Deferred();

      options.model.fetch(_underscore.default.extend({}, options, {
        success: deferred.resolve,
        error: deferred.reject
      }));
      return deferred.promise();
    };
  },
  _startTrackingModels: function _startTrackingModels(models) {
    var view = this;
    models = _underscore.default.isArray(models) ? models : models ? [models] : [];

    _underscore.default.each(models, function (model) {
      model.unsaved = {
        prompt: 'There are unsaved Changes.',
        unloadWindowPrompt: true,
        unloadRouterPrompt: true,
        unloadRouterPromptAsync: function unloadRouterPromptAsync(fragment, options, done) {
          _backbone.default.trigger('navigate-unsaved-changes', model, view, fragment, options, done);
        }
      };
      model.startTracking && model.startTracking();
      modelsToTrack.push(model);
      this._modelsToTrack = this._modelsToTrack || [];

      this._modelsToTrack.push(model);
    }, this);
  },
  _stopTrackingModels: function _stopTrackingModels(models) {
    models = _underscore.default.isArray(models) ? models : models ? [models] : [];

    _underscore.default.each(models, function (model) {
      model.stopTracking && model.stopTracking();
      this.stopListening(model, 'unsavedChanges');
      model.unsaved = null;
      modelsToTrack = _underscore.default.without(modelsToTrack, model);
      this._modelsToTrack = this._modelsToTrack || [];
      this._modelsToTrack = _underscore.default.without(this._modelsToTrack, model);

      if (model == modelForSave) {
        this._setModelForSave(null);
      }
    }, this);

    if (handleSaveHandler === this._formViewMixinOptions.handleSaveHandler) {
      handleSaveHandler = null;
    }
  },
  _resetTrackingForAllModels: function _resetTrackingForAllModels() {
    _underscore.default.each(modelsToTrack, function (model) {
      model._trackingChanges && model._resetTracking();
    });

    _underscore.default.each(modelsToTrack, function (model) {
      model._trackingChanges && model._triggerUnsavedChanges();
    });
  },
  _setModelForSave: function _setModelForSave(model) {
    modelForSave && this.stopListening(modelForSave, 'sync', this._resetTrackingForAllModels);
    modelForSave = model;
    modelForSave && this.listenTo(modelForSave, 'sync', this._resetTrackingForAllModels);
  },
  _setHandleSaveHandler: function _setHandleSaveHandler(handler) {
    handleSaveHandler = handler;
  },
  _bindModelForChanges: function _bindModelForChanges(models) {
    this._startTrackingModels(models);
  },
  _unbindModelForChanges: function _unbindModelForChanges() {
    this._stopTrackingModels(this._modelsToTrack);
  },
  _showErrorMessageCounter: 0,
  _showErrorMessage: function _showErrorMessage(message) {
    var thisView = this;
    var element = this.$('.save-button-error-label');

    if (element.length === 0) {
      return;
    }

    this._showErrorMessageCounter++;
    var counter = this._showErrorMessageCounter;
    element.text(message).addClass('collapse').addClass('error-visible').collapse({
      toggle: false
    }).collapse('show');

    _underscore.default.delay(function () {
      if (counter !== thisView._showErrorMessageCounter) {
        return;
      }

      element.collapse('hide');

      _underscore.default.delay(function () {
        if (counter === thisView._showErrorMessageCounter) {
          return;
        }

        element.empty();
      }, 600);
    }, 5000);
  },
  _validateModels: function _validateModels() {
    return _underscore.default.every(modelsToTrack || [], function (model) {
      var valid = !model.isValid || model.isValid(true);

      if (!valid) {
        var invalidAttributes = model.validate(false, {
          forceUpdate: false
        });

        var errors = _underscore.default.values(invalidAttributes).join(', ');

        var message = 'Fix the errors before saving: ' + errors + '.';

        this._showErrorMessage(message);

        _backbone.default.trigger('triggerNotification', {
          message: message,
          type: 'error',
          showCloseButton: true
        });
      }

      return valid;
    }, this);
  },
  _saveModel: function _saveModel(options) {
    options = options || {};
    var hideSuccessMessage = options.hideSuccessMessage;
    var timeout = options.timeout || 30000;
    var model = options.model || this.model;

    _backbone.default.trigger('removeNotification', 'unsaved-changes-message');

    if (!this._validateModels()) {
      options.validationError && _underscore.default.defer(options.validationError);
      return false;
    }

    if (model.isValid && !model.isValid(true)) {
      var invalidAttributes = model.validate(false, {
        forceUpdate: false
      });

      var errors = _underscore.default.values(invalidAttributes).join(', ');

      _backbone.default.trigger('triggerNotification', {
        message: 'Fix the errors before saving: ' + errors + '.',
        type: 'error',
        showCloseButton: true
      });

      options.validationError && _underscore.default.defer(options.validationError);
      return false;
    }

    var thisView = this;
    var attrs = null;
    options.patch = _underscore.default.has(options, 'patch') ? options.patch : model.preferPatch;

    if (options.patch) {
      attrs = model.unsavedAttributes() || {};

      _underscore.default.each(attrs, function (value, key) {
        if (_underscore.default.isUndefined(value)) {
          attrs[key] = null;
        }
      });
    }

    model.save(attrs, {
      success: function success(model, response) {
        !hideSuccessMessage && _backbone.default.trigger('triggerNotification', {
          message: thisView.successMessage || 'Successfully saved',
          type: 'success',
          showCloseButton: true
        });
        options.success && options.success(response);
      },
      error: function error(model, _error) {
        if (thisView.saveErrorHandler) {
          thisView.saveErrorHandler(_error);
        } else {
          _backbone.default.trigger('triggerNotification', {
            message: thisView.errorMessage || 'Save could not be completed',
            type: 'error',
            showCloseButton: true
          });

          options.error && options.error(_error);
        }
      },
      patch: options.patch,
      timeout: timeout
    });
    return true;
  }
};
var _default = TrackingMixin;
exports.default = _default;